var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6742 21.3643H3.51162C3.03033 21.3643 2.64001 20.9739 2.64001 20.4927V6.33006C2.64001 5.84877 3.03033 5.45845 3.51162 5.45845H10.5928C11.0741 5.45845 11.4644 5.84877 11.4644 6.33006C11.4644 6.81135 11.0741 7.20166 10.5928 7.20166H4.38303V19.6212H16.8026V13.4114C16.8026 12.9302 17.1929 12.5398 17.6742 12.5398C18.1555 12.5398 18.5458 12.9302 18.5458 13.4114V20.4927C18.5456 20.9739 18.1555 21.3643 17.6742 21.3643Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.105 4.96609L19.0699 2.93105C18.73 2.58903 18.1766 2.58903 17.8366 2.93105L16.0152 4.7525C16.0086 4.75681 16.0021 4.76336 15.9955 4.77216H15.9933L8.87952 11.8884C8.80108 11.9668 8.73781 12.0604 8.69438 12.1607L7.16926 15.7209C7.0298 16.0478 7.10393 16.4268 7.3544 16.6796C7.52213 16.8473 7.74434 16.9345 7.97104 16.9345C8.08654 16.9345 8.2041 16.9128 8.3153 16.8649L11.8734 15.3418C11.9758 15.2982 12.0673 15.2351 12.1458 15.1567L21.1052 6.19731C21.4449 5.85735 21.4449 5.30605 21.105 4.96609ZM11.0321 13.8059L9.62888 14.4051L10.2302 13.0018L16.4574 6.77688L17.2591 7.57865L11.0321 13.8059ZM18.1832 6.65482L17.3814 5.8508L18.4533 4.77889L19.2551 5.58067L18.1832 6.65482Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d51043483042371f1f911ae508911d5f.svg";
export { ForwardRef as ReactComponent };